import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const useMaintenanceMode = () => {
  // Optimistic default: render the app immediately and check maintenance status
  // in the background. If maintenance is actually enabled, `enabled` flips to
  // true once the check resolves and the MaintenanceWrapper shows the page.
  // This avoids blocking the entire app behind a single (occasionally flaky)
  // network request on first paint.
  const [maintenanceStatus, setMaintenanceStatus] = useState({
    enabled: false,
    message: null,
    eta: null,
    loading: false,
    error: null
  });

  const checkMaintenanceStatus = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/maintenance/status`, {
        timeout: 5000
      });
      setMaintenanceStatus({
        enabled: response.data.enabled,
        message: response.data.message,
        eta: response.data.eta,
        loading: false,
        error: null
      });
      return response.data;
    } catch (error) {
      // If we can't reach the API, assume no maintenance mode so the app
      // remains accessible if the maintenance endpoint fails.
      setMaintenanceStatus({
        enabled: false,
        message: null,
        eta: null,
        loading: false,
        error: error.message
      });
      return { enabled: false };
    }
  }, []);

  useEffect(() => {
    checkMaintenanceStatus();
  }, [checkMaintenanceStatus]);

  return {
    ...maintenanceStatus,
    checkMaintenanceStatus
  };
};
